export default __webpack_public_path__ + "static/media/ceo1.39152fe3.jpg";